import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfNoneFoundIconProps extends SvgIconProps {}

/**
 * Component used to render none found icon and page
 * @example
 */
export function CcfNoneFoundIcon(props: CcfNoneFoundIconProps) {
  return (
    <SvgIcon
      {...props}
      width="260.449"
      height="147.289"
      viewBox="0 0 260.449 147.289"
    >
      <g id="none_found" transform="translate(-0.213 0.01)">
        <path
          id="Path_30176"
          data-name="Path 30176"
          d="M19.939,120.99S-16.019,81.828,9.162,45.336C18.551,31.679,42.56,24.1,64.756,30.292c13.018,3.629,31.266,12.593,50.578-19.741C238.471-6.629,289.473,38.079,244.341,60.49c-29.13,22.3,11.63,27.742-4.907,60.5H19.944Z"
          transform="translate(0 25.321)"
          fill="#c1d6eb"
          opacity="0.4"
        />
        <path
          id="Path_30177"
          data-name="Path 30177"
          d="M1.552,30.7H256.786a.462.462,0,0,1,.429.429h0a.462.462,0,0,1-.429.429H1.552a.457.457,0,0,1-.424-.429h0a.39.39,0,0,1,.424-.429h0Z"
          transform="translate(3.447 115.721)"
          fill="#5b7c8c"
        />
        <path
          id="Path_30178"
          data-name="Path 30178"
          d="M36.032,6.991s-2.241-3.948,0-4.7,3.2-.1,3.309.854a22.17,22.17,0,0,1-.854,4.482l-2.456-.639Z"
          transform="translate(131.224 7.452)"
          fill="#ffb27d"
        />
        <path
          id="Path_30179"
          data-name="Path 30179"
          d="M60.669,28.951a76.648,76.648,0,0,1-11.1,1.173,57.513,57.513,0,0,1-8.535-.424c-.639-.1-1.283-.1-1.922-.215A36.527,36.527,0,0,1,28.979,26.71s5.975-12.483,10.776-12.059c5.655.534,15.259,5.655,16.217,4.268,1.068-1.6,1.922-15.364,1.922-15.364,2.456-1.707,3.948.1,3.948.1S66.859,27.883,60.669,28.951Z"
          transform="translate(108.399 10.674)"
          fill="#a9dff8"
        />
        <path
          id="Path_30180"
          data-name="Path 30180"
          d="M52.3,13.743a76.649,76.649,0,0,1-11.1,1.173,57.513,57.513,0,0,1-8.535-.424c-1.492-4.8-2.561-9.708.429-6.723C38.438,13,52.309,13.743,52.309,13.743Z"
          transform="translate(116.763 25.881)"
          fill="#95c9de"
        />
        <path
          id="Path_30181"
          data-name="Path 30181"
          d="M28.957,31.075s-.429,5.016.639,5.55H43.043s0-1.6-2.136-1.922-5.975-1.6-6.614-4.482c-.749-2.88-5.336.854-5.336.854Z"
          transform="translate(107.996 109.81)"
          fill="#233862"
        />
        <path
          id="Path_30182"
          data-name="Path 30182"
          d="M44.442,29.184c-.1,3.2-.215,6.614-.534,9.6-1.492,14.3-1.922,31.69-2.136,35-.319,5.76-1.492,15.044-1.492,15.044S38.039,90.967,33.556,90a148.555,148.555,0,0,1-4.482-27.423v-.639c-.1-1.812-.215-3.948-.319-6.294-.639-15.364-1.388-38.094-1.388-38.094l16.861-3.948S44.657,21.073,44.442,29.184Z"
          transform="translate(102.324 51.31)"
          fill="#004b72"
        />
        <path
          id="Path_30183"
          data-name="Path 30183"
          d="M44.442,29.184C40.175,36.546,32.064,50.2,28.755,55.648c-.639-15.364-1.388-38.094-1.388-38.094l16.861-3.948S44.657,21.073,44.442,29.184Z"
          transform="translate(102.324 51.31)"
          fill="#233862"
        />
        <path
          id="Path_30184"
          data-name="Path 30184"
          d="M24.729,13.878s-2.775,3.2-2.99,4.163a16.641,16.641,0,0,0-.429,5.121c.215.958,2.027-2.665,2.665-3.095s-.534,1.492-.215,1.812c.215.319,1.492-1.068,2.027-1.6s.429-2.99,1.068-4.482c.639-1.6-2.136-1.922-2.136-1.922Z"
          transform="translate(79.357 52.316)"
          fill="#ffb27d"
        />
        <path
          id="Path_30185"
          data-name="Path 30185"
          d="M23.422,29.109s-2.346,2.136-1.922,3.734,2.665,2.561,2.88,4.482c.319,1.922,1.492,2.99,2.456,2.99h5.016s.749-1.283-1.068-1.707-2.561-2.666-2.456-4.7a35.965,35.965,0,0,0-.215-4.8l-3.948-.958-.749.958Z"
          transform="translate(80.024 106.12)"
          fill="#233862"
        />
        <path
          id="Path_30186"
          data-name="Path 30186"
          d="M62.3,18.657S46.51,52.588,38.08,67.422,27.089,86.415,27.089,86.415s-4.8-1.922-5.226-3.2c0,0,3.2-28.705,8.855-35.748,3.2-3.948,6.938-15.793,7.043-19.955S41.6,13.426,41.6,13.426l20.7,5.231Z"
          transform="translate(81.583 50.631)"
          fill="#004b72"
        />
        <path
          id="Path_30187"
          data-name="Path 30187"
          d="M53.608,53.674a27.977,27.977,0,0,1-15.154,3.843c-3.843-.215-11.63-1.283-12.913-4.373-.319-.749-.1-1.6.319-3.095C27.034,46.317,29.7,39.274,28.85,23.7a25.808,25.808,0,0,1,.1-4.053c.854-7.682,5.226-12.269,9.5-13.766C48.806,2.248,52.22,7.264,52.22,7.264A16.546,16.546,0,0,1,57.451,18.47c1.492,15.154-3.843,35.214-3.843,35.214Z"
          transform="translate(94.866 17.216)"
          fill="#a9dff8"
        />
        <path
          id="Path_30188"
          data-name="Path 30188"
          d="M28.778,12.221A16.186,16.186,0,0,0,38.7,14.248s.958-.215.534-1.492a9.069,9.069,0,0,0,.429-1.6A21.261,21.261,0,0,0,40.2,8.593L37.318,5.5l-2.775-2.88a12.061,12.061,0,0,1-5.76,9.6Z"
          transform="translate(107.641 9.903)"
          fill="#ffb27d"
        />
        <path
          id="Path_30189"
          data-name="Path 30189"
          d="M29.9,3.178a11.641,11.641,0,0,0,5.55,5.975c.429-1.6.749-3.414.749-3.414L33.1,3.393l-3.2-.215Z"
          transform="translate(111.854 12.014)"
          fill="#ed985f"
        />
        <path
          id="Path_30190"
          data-name="Path 30190"
          d="M40.09,15.6s-9.069,1.173-9.708-4.482C29.743,5.566,28.141,1.942,33.9.979s7.148,1.068,7.791,2.88C42.441,5.671,42.441,15.169,40.09,15.6Z"
          transform="translate(111.054 2.793)"
          fill="#ffb27d"
        />
        <path
          id="Path_30191"
          data-name="Path 30191"
          d="M29.753,2.813c-.1-.1-.215-.215-.639-.215a2.022,2.022,0,0,1,.749-.215A2.046,2.046,0,0,1,31.355.572a1.657,1.657,0,0,0-.639.854C31.889.252,34.45-.5,41.388.357c9.069,1.068,5.87,6.828,4.7,7.467-1.388.639-4.268-1.388-6.509-1.283S36.8,9.851,36.057,10.171c-.749.429-.429-.319-1.388-.854s-1.173,1.173-.854,2.241-1.173,2.456-1.173,2.456l-1.388-1.6c-1.388-1.6-2.456-8-1.707-9.389,0,.1.1-.1.215-.215Z"
          transform="translate(108.907 0)"
          fill="#2c3a64"
        />
        <path
          id="Path_30192"
          data-name="Path 30192"
          d="M47.262,5.162l-15.364.1-.1-2.346L47.158,1.748Z"
          transform="translate(119.006 6.625)"
          fill="#2a4e96"
        />
        <path
          id="Path_30193"
          data-name="Path 30193"
          d="M50.885,6.771l-16.751.215-.215-4.268L50.67,1.435Z"
          transform="translate(127.014 5.445)"
          fill="#2a4e96"
        />
        <path
          id="Path_30194"
          data-name="Path 30194"
          d="M51.15,8.1H37.065L36.85,2.449,50.936,1.166,51.15,8.1Z"
          transform="translate(138.059 4.432)"
          fill="#233862"
        />
        <path
          id="Path_30195"
          data-name="Path 30195"
          d="M40.821,9.906h0a.826.826,0,0,0,.749-.854L41.25,1.691A.829.829,0,0,0,40.4.942h0a.823.823,0,0,0-.749.854l.319,7.362A.905.905,0,0,0,40.821,9.906Z"
          transform="translate(148.603 3.588)"
          fill="#233862"
        />
        <path
          id="Path_30196"
          data-name="Path 30196"
          d="M32.491,5.213h0a.713.713,0,0,1-.749-.639h0l-.1-1.922a.716.716,0,0,1,.639-.749h0a.713.713,0,0,1,.749.639h0l.1,1.922a.713.713,0,0,1-.639.749Z"
          transform="translate(118.415 7.213)"
          fill="#2a4e96"
        />
        <path
          id="Path_30197"
          data-name="Path 30197"
          d="M25.511,38.122c1.173-3.734,3.843-10.776,2.99-26.355a25.808,25.808,0,0,1,.1-4.053h0c3.414-.319,8.645,3.414,8.645,3.414s-3.2,19.631-11.74,27Z"
          transform="translate(95.33 29.035)"
          fill="#95c9de"
        />
        <path
          id="Path_30198"
          data-name="Path 30198"
          d="M55.171,4.636s-8.75,1.492-13.337,7.043S29.99,25.23,28.283,27.9c-1.707,2.775-6.509,21.553-6.509,21.553a2.363,2.363,0,0,0,1.6.958,2.936,2.936,0,0,0,2.136-.215s6.4-10.991,8.75-16.432c.958-2.241,18.248-11.31,24.757-10.352,2.561.424-3.843-18.778-3.843-18.778Z"
          transform="translate(81.248 17.489)"
          fill="#a9dff8"
        />
        <path
          id="Path_30199"
          data-name="Path 30199"
          d="M35.021,2.1s1.922,1.173,2.99.639,1.068-.958,1.068-.958S35.665.927,35.026,2.1Z"
          transform="translate(131.167 5.619)"
          fill="#ffb27d"
        />
        <path
          id="Path_30200"
          data-name="Path 30200"
          d="M57.47,6.243S53.627,30.571,26.419,37.614l-2.99,5.87,5.226.854S59.6,35.373,59.172,5.819l-1.707.429Z"
          transform="translate(87.484 21.966)"
          fill="#bc3f3f"
        />
        <path
          id="Path_30201"
          data-name="Path 30201"
          d="M31.448,5.106l-1.283.1V7.023l1.812,1.922,1.707-.429V5.955L32.511,5.1H31.443Z"
          transform="translate(112.868 19.26)"
          fill="#a02e2e"
        />
        <path
          id="Path_30202"
          data-name="Path 30202"
          d="M32.524,4.1s-1.173.319-3.948,2.561c0,0,2.775,5.87,8.645,6.614A20.168,20.168,0,0,1,37.54,8.9c-.1,0-4.7-1.707-5.016-4.8Z"
          transform="translate(106.88 15.469)"
          fill="#95c9de"
        />
        <path
          id="Path_30203"
          data-name="Path 30203"
          d="M30.434,6.364s2.88,1.492,3.095,3.843a4.7,4.7,0,0,0,.749-2.88,9.613,9.613,0,0,0-1.283-2.561s.1,1.388-2.561,1.6Z"
          transform="translate(113.882 18.001)"
          fill="#95c9de"
        />
      </g>
    </SvgIcon>
  );
}

export default CcfNoneFoundIcon;
